









































































































































































import { Component, Vue } from 'vue-property-decorator';
import '../css/prioritiztion.less';
import DetailedInformation from '@/prioritization/detailedInformation/detailed-information.vue';
import Api from '@/Api/api_simulaion';
import { getQueryString } from '@/Api/api_data';
import MessageBus from '@/Utils/message/message-bus';
import { DeviceParameterColumns, PlanData, PlanList, Log } from '../interface/interface';
import run_time from '@/Utils/run_time';
import ProjectExportTool from '@/Utils/project-export-tool';
import { dateParse } from '@/Utils/date-format';

import { profile } from '@/Utils/profile';
const ieslabDisableRules = profile.get('ieslabDisableRules') === 'true';

/**
 * @author guan
 * @description 方案优选
 */
@Component({
    components: { DetailedInformation },
})
export default class PrioritizationScheme extends Vue {
    /** disabledFunction */
    disabledFunction = false;
    /** 任务id */
    taskId = '';
    /** */
    relatedTaskId = '';
    /** */
    informationTaskId = '';
    /** 对比方案列表 */
    relatedPlanList: PlanList[] = [];
    /** 当前算例运行状态 */
    simulation = {
        /** 正在运行 */
        isRunning: false,
        /** 进程说明 */
        progress: 0,
    };
    /** 加载列表效果 */
    loadingDeviceParameterList = false;
    /** tableType  */
    tableType: 'plan' | 'device' = 'plan';
    /** */
    contrastivePlanIndex = 0;
    /** 设备参数列表 */
    deviceParameterList = {} as PlanData;
    /** 方案列表 */
    packageList = [
        {
            title: '经济性最优',
            desc: '以系统经济性为优化目标，将系统综合成本最小作为目标函数（综合成本是指系统建设成本平摊至每年并与年运行成本和设备维护成本的加和），算法将根据该指标计算获得多种系统配置和运行方案，并按照从劣至优进行排序。',
            /** 0为经济性 */
            type: 0,
        },
        {
            title: '环保性最优',
            desc: '以系统环保性为优化目标，将系统运行过程中所排放的二氧化碳、二氧化硫等污染物的总量最小作为目标函数，算法将根据该指标计算获得多种系统配置和运行方案，并按照从劣至优进行排序。',
            /** 1为环保性 */
            type: 1,
        },
        // {
        //     title: '可靠性最优',
        //     desc: '考虑新能源等设备的不确定性对系统供能的影响，分析计算供能可靠性指标，通过调整新能源设备的配置规模，实现系统配置和运行方案的生成，并根据综合成本按照从劣至优进行排序。',
        //     /**2为可靠性 */
        //     type: 2,
        // },
    ];

    /** */
    tableColumns: Array<Record<string, unknown>> = [
        { dataIndex: 'name', key: 'name', title: '方案名称', scopedSlots: { customRender: 'solutionName' }, align: 'center' },
        {
            width: 100,
            dataIndex: '综合成本(万元)',
            key: '综合成本(万元)',
            title: '综合成本(万元)',
            align: 'center',
        },
        { dataIndex: '设备投资费用(万元)', width: 100, key: '设备投资费用(万元)', title: '设备投资费用(万元)', align: 'center' },
        { dataIndex: '设备年维护费用(万元)', width: 100, key: '设备年维护费用(万元)', title: '设备年维护费用(万元)', align: 'center' },
        { dataIndex: '年销售收入(万元)', width: 100, key: '年销售收入(万元)', title: '年销售收入(万元)', align: 'center' },
        { dataIndex: '年运营支出(万元)', width: 100, key: '年运营支出(万元)', title: '年运营支出(万元)', align: 'center' },
        { dataIndex: '年CO2排放(吨)', width: 100, key: '年CO2排放(吨)', title: '年CO2排放(吨)', align: 'center' },
        { dataIndex: '年NOX排放(吨)', width: 100, key: '年NOX排放(吨)', title: '年NOX排放(吨)', align: 'center' },
        { dataIndex: '年SO2排放(吨)', width: 100, key: '年SO2排放(吨)', title: '年SO2排放(吨)', align: 'center' },
        { dataIndex: '年烟尘排放(吨)', width: 100, key: '年烟尘排放(吨)', title: '年烟尘排放(吨)', align: 'center' },
        { dataIndex: '年电负荷(kWh)', width: 100, key: '年电负荷(kWh)', title: '年电负荷(kWh)', align: 'center' },
        { dataIndex: '年热负荷(kWh)', width: 100, key: '年热负荷(kWh)', title: '年热负荷(kWh)', align: 'center' },
        { dataIndex: '年冷负荷(kWh)', width: 100, key: '年冷负荷(kWh)', title: '年冷负荷(kWh)', align: 'center' },
        { dataIndex: '年蒸汽负荷(kWh)', width: 100, key: '年蒸汽负荷(kWh)', title: '年蒸汽负荷(kWh)', align: 'center' },
        { dataIndex: '', title: '操作', width: 120, key: 'action', scopedSlots: { customRender: 'action' }, align: 'center', fixed: 'right' },
    ];

    /** showLog */
    showLog = 0;

    /**
     * logInfo
     */
    logInfo: Log[] = [];

    /**
     *获取计划列表
     */
    get planList(): PlanList[] {
        return this.$store.getters.getPlanList;
    }

    set planList(value: PlanList[]) {
        this.$store.commit('setPlanList', value);
    }

    /**
     * @author guan
     * @description 获取当前方案下的数据
     * @return void
     */
    get dataByPlan(): Array<Record<string, string>> {
        const data = this.planList.find((x) => x.id === this.plan);
        if (data) {
            return data.data.data as unknown as Array<Record<string, string>>;
        } else return [];
    }

    /**
     *获取关联表格数据
     */
    get relatedPlanTableData(): Array<Record<string, string | number>> {
        const result = new Array<Record<string, string | number>>();

        this.relatedPlanList.forEach((item, index) => {
            const rowData: Record<string, string | number> = {};
            rowData['name'] = item.name;
            rowData['key'] = index;
            rowData['id'] = item.id;
            item.data.data.forEach((dataItem) => {
                if (typeof dataItem.optimizedSystem === 'number') {
                    rowData[dataItem.term] = dataItem.optimizedSystem.toFixed(2);
                } else {
                    rowData[dataItem.term] = dataItem.optimizedSystem;
                }
            });
            result.push(rowData);
        });
        return result;
    }

    /**
     *获取表格数据
     */
    get tableData(): Array<Record<string, string | number>> {
        const result = new Array<Record<string, string | number>>();
        const headerDesc = this.planList[0]?.data.headerDesc;
        if (headerDesc) {
            const tableColumns: Array<Record<string, unknown>> = headerDesc.map((column) => ({
                dataIndex: column.key,
                key: column.key,
                title: column.hearderName,
                align: 'center',
            }));
            tableColumns.push({
                dataIndex: '',
                title: '操作',
                width: 120,
                key: 'action',
                scopedSlots: { customRender: 'action' },
                align: 'center',
                fixed: 'right',
            });
            this.tableColumns = tableColumns;
        }
        this.planList.forEach((item, index) => {
            item.data.data.forEach((dataItem) => {
                const rowData: Record<string, string | number> = {};
                rowData['name'] = item.name;
                rowData['key'] = index;
                rowData['id'] = item.id;
                for (const key in dataItem) {
                    if (!isNaN(dataItem[key])) {
                        rowData[key] = dataItem[key].toFixed(2);
                        continue;
                    }
                    rowData[key] = dataItem[key];
                }
                result.push(rowData);
            });
        });
        if (this.relatedPlanList && this.relatedPlanList.length > 0) {
            const contrastivePlan = { ...this.relatedPlanTableData[this.contrastivePlanIndex] };
            contrastivePlan.key = -1;
            result.unshift(contrastivePlan);
        }
        return result;
    }
    /**
     *停止计算
     */
    async stopCalculate(): Promise<void> {
        if (this.disabledFunction) {
            return;
        }
        await Api.removeOptimizationTask({ taskid: this.taskId, stopFlag: 1 });
        await this.loadLastSimulationTask();
    }

    /**
     *删除任务
     */
    async deleteTask(): Promise<void> {
        if (this.disabledFunction) {
            return;
        }
        this.$store.commit('setCurrentPlanId', 1);
        await Api.removeOptimizationTask({ taskid: this.taskId, stopFlag: 2 });
        await this.loadLastSimulationTask();
    }

    /**
     * @author guan
     * @description  开始计算获取数据
     * @return void
     */
    startCalculate(): void {
        if (this.disabledFunction) {
            return;
        }
        let params: Record<string, unknown> = {};
        params['OptimizationMode'] = this.modeCode;
        params['ProjectPeriod'] = '20';
        const param: {
            [key: string]: string | number;
        } = {
            simuid: getQueryString()['simu_id'],
            optPara: JSON.stringify(params),
        };
        Api.runOptimization(param)
            .then(() => {
                // if (!(data as Record<string, unknown>).error) {
                //     MessageBus.Notification('success', { description: (data as Record<string, unknown>).message as string, message: '提示' });
                // } else {
                //     MessageBus.Notification('error', { description: (data as Record<string, unknown>).message as string, message: '提示', duration: 10 });
                // }
            })
            .then(() => {
                this.loadLastSimulationTask().catch((e) => e);
            })
            .catch((e) => e);
    }
    /** 当前选择浏览的方案,default 为1 */
    plan = 1;
    /**
     * @author guan
     * @description 加载算例数据
     * @return New Promise
     */
    async loadLastSimulationTask(): Promise<void> {
        const simuid = getQueryString()['simu_id'];
        /** 获取最后一次算例的id,以及更新状态量 */
        await Api.getLastSimulationTask({ simuid: simuid })
            .then((res) => {
                switch (res.error) {
                    case 0: {
                        if (res.data != null) {
                            this.taskId = res.data.task_id;
                            this.modeCode = <number>res.data.optimizationpara['OptimizationMode'] || 0;
                            this.simulation.isRunning = res.data.status !== 'stop';
                        }
                        return res;
                    }
                    case -1: {
                        // MessageBus.Notification('error', { description: '未开始运行', message: '提示' });
                        this.simulation.isRunning = false;
                        return res;
                    }
                    default: {
                        // MessageBus.Notification('error', { description: '未知错误，请联系管理员', message: '' });
                        this.simulation.isRunning = false;
                        return res;
                    }
                }
            })
            .catch((e) => e);
        await Api.getSimuLog({ simuid: simuid, taskid: this.taskId })
            .then((data) => {
                this.simulation.progress = Number((data.progress.data || 0).toFixed(2));
                const log = data.msg.map((x) => {
                    return {
                        id: x.id,
                        cmd: x.cmd,
                        addtime: x.addtime,
                        createdate: dateParse('yyyy-mm-dd hh:MM:ss', x.createdate),
                        data: x.data,
                    };
                });
                this.logInfo = log;
                const runEnd = log.find((value) => value.data === 'run ends');
                if (runEnd) {
                    this.simulation.isRunning = false;
                }
                if (this.simulation.progress === 100) {
                    this.simulation.isRunning = false;
                }

                data.msg.forEach((item) => {
                    if (item['cmd'] === 'error') {
                        // MessageBus.Notification('error', { description: item['data'], message: '运算时发生错误', duration: 10000 });
                        this.simulation.isRunning = false;
                    }
                });
                /** 判断当前处于停止状态 */
                this.getSimulationResult();
                if (this.simulation.isRunning) {
                    const runTime = new run_time();
                    /** 循环获取数据 */
                    runTime._setTimeout(() => {
                        if (this.simulation.isRunning) {
                            this.loadLastSimulationTask().catch((e) => e);
                        }
                    }, 10000);
                }
            })
            .catch((e) => e);
    }

    /**
     * @author guan
     * @description 获取算例列表
     * @return void
     */
    getSimulationResult(): void {
        const id = getQueryString()['simu_id'] as unknown as number;
        const taskId = this.taskId;
        Api.getOptimizationResult({ resultType: 0, simuid: id, taskid: taskId })
            .then((res) => {
                this.planList = res.data;
                if (this.planList.length === 0) {
                    this.$store.commit('setCurrentPlanId', 1);
                }
            })
            .catch((e) => e);
    }
    /**
     *
     */
    async getRelatedPlanList(): Promise<void> {
        const id = getQueryString()['simu_id'] as unknown as number;
        const responseData = await Api.getRelatedOptimizationResult({ resultType: 0, simuid: id });
        this.relatedPlanList = responseData.data;
        if (responseData.data && responseData.data.length > 0) {
            const taskData = await Api.getLastSimulationTask({ simuid: responseData.simu });
            if (taskData.data) {
                this.relatedTaskId = taskData.data.task_id;
            }
        }
    }

    /** 选择方案的类型 */
    modeCode = 0;
    /**
     * @author guan
     * @description 加载最后的算例
     * @return void
     */
    mounted(): void {
        if (window.innerWidth < 1400) {
            this.tableColumns[0].width = 150;
        }
        this.loadLastSimulationTask().catch((e) => e);
        this.disabledFunction = ieslabDisableRules;
    }
    /**
     * @author guan
     * @description 选择对应的计算方案
     * @return void
     * @param e 当前选择的modeCode
     */
    onChange(e: { title: string; type: number; desc: string }): void {
        if (this.modeCode === e.type) {
            MessageBus.Message('warning', '至少要选择一个优化目标！');
        } else this.modeCode = e.type;
    }
    /** 预设颜色 */
    readonly colorList = ['#0497f8', '#49269a', '#20a84e', '#c1a621', '#000', '#0497f8', '#49269a', '#20a84e', '#0497f8', '#49269a'];
    /** 切换当前页面的变量 */
    active = '方案列表';

    /**
     * @author guan
     * @description  初始化详细信息页面，添加从后台获取优化结果数据的方法，并将数据加载到前端页面中
     * @return void
     */
    initDetail(planId: number, taskId: string): void {
        this.informationTaskId = taskId;
        this.plan = planId;
        this.active = '详细信息';
    }
    /**
     * 获取参数列表
     */
    async getDeviceParameterList(): Promise<void> {
        /** 映射表 */
        this.loadingDeviceParameterList = true;

        const planDataList = this.planList.map((x) => {
            return Api.getOptimizationResult({ resultType: 1, simuid: getQueryString()['simu_id'], taskid: this.taskId, planId: x.id });
        });
        const data = await Promise.all(planDataList);
        if (!data) {
            void this.$message.error('获取数据错误');
            return;
        }
        let columns = [] as DeviceParameterColumns[];
        let DeviceParameterList = [] as Array<Record<string, string | number>>;
        data.forEach((dataItem, index) => {
            const planData = dataItem.data;
            columns.push({
                title: `方案${index + 1}`,
                children: [
                    {
                        title: '生产厂商',
                        dataIndex: `compManufacturer_${index}`,
                        key: `compManufacturer_${index}`,
                        width: 100,
                        align: 'center',
                    },
                    {
                        title: '设备型号',
                        dataIndex: `compModel_${index}`,
                        key: `compModel_${index}`,
                        width: 100,
                        align: 'center',
                    },
                    {
                        title: '设备台数',
                        dataIndex: `deviceNum_${index}`,
                        key: `deviceNum_${index}`,
                        width: 100,
                        align: 'center',
                    },
                    {
                        title: '设备投资费用(万元)',
                        dataIndex: `devicePurchaseCost_${index}`,
                        key: `devicePurchaseCost_${index}`,
                        width: 100,
                        align: 'center',
                    },
                ],
            });
            const DeviceData = planData.map((x) => {
                return {
                    compName: x.data.data['compName'],
                    [`compManufacturer_${index}`]: x.data.data['compManufacturer'],
                    [`compModel_${index}`]: x.data.data['compModel'],
                    [`deviceNum_${index}`]: x.data.data['deviceNum'],
                    [`devicePurchaseCost_${index}`]: x.data.data['devicePurchaseCost'],
                };
            });
            if (DeviceParameterList.length === 0) {
                DeviceParameterList = DeviceData;
            } else
                DeviceParameterList = DeviceParameterList.map((x, key) => {
                    return { ...x, ...DeviceData[key], key: key };
                });
        });
        columns.unshift({
            title: 'Unique Name',
            dataIndex: 'compName',
            key: `compName`,
            width: 150,
            align: 'center',
        });
        this.deviceParameterList.detailColumn = columns;

        DeviceParameterList.splice(
            DeviceParameterList.findIndex((x) => x['compName'] === 'systemData'),
            1,
        );
        this.deviceParameterList.data = DeviceParameterList;
        this.tableType = 'device';
        this.loadingDeviceParameterList = false;
    }

    /**
     *导出项目
     */
    async exportProject(): Promise<void> {
        const exportProjectTool = new ProjectExportTool();
        await exportProjectTool.exportToFiles();
    }

    /**
     * 空函数
     */
    emptyFunction(): void {
        console.log(1111);
        return;
    }
}
